export default {
    doctor: {
        "en": "Doctor",
        "ar": 'زبون تجزئة',
    },
    doctorVisits: {
        "en": "Doctor visits",
        "ar": "زيارات زبون التجزئة"
    },
    doctors: {
        "en": "Doctors",
        "ar": "زبائن التجزئة"
    },
    pharmacy: {
        "en": "Pharmacy",
        "ar": "زبون الجملة"
    },
    pharmacies: {
        "en": "Pharmacies",
        "ar": "زبائن الجملة"
    },
    center: {
        "en": "Center",
        "ar": "المركز"
    },
    centers: {
        "en": "Centers",
        "ar": "المراكز "
    },
    pharmacyVisits: {
        "en": "Pharmacy visits",
        "ar": "زيارات زبون الجملة"
    },
    centerVisits: {
        "en": "Center visits",
        "ar": "زيارات المراكز "
    },
    medicalRep: {
        "en": "Medical rep",
        "ar": "مندوبين"
    },
    
    doctorName: {
        "en": "Doctor name",
        "ar": "اسم زبون التجزئة"
    },
    doctorHobbies: {
        "en": "Doctor hobbies",
        "ar": "عادات زبون التجزئة"
    },
    editDoctor: {
        "en": "Edit doctor",
        "ar": "تعديل زبون"
    },

    deleteDoctor: {
        "en": "Delete doctor",
        "ar": "حذف زبون"
    },
    centerNotes: {
        "en": "Center notes",
        "ar": "ملاحظات مراكز"
    },

    pharmaceuticalForms: {
        "en": "Pharmaceutical forms",
        "ar": "الأشكال"
    },

    pillsPerBox: {
        "en": "Pills per box",
        "ar": 'عدد القطع في الصندوق',
    },

    medRepPlan: {
        "en": "medical.Rep plan",
        "ar": "خطة مندوب"
    },

    medRepZone: {
        "en": "medical.Rep zone",
        "ar": "قسم المندوب "
    },

    medRepMark: {
        "en": "Medical.Rep mark",
        "ar": "تقييم المندوب "
    },

    addNewDoctor: {
        "en": "Add new doctor",
        "ar": "إضافة زبون جديد"
    },

    specialty: {
        "en": "specialty",
        "ar": "تخصص الزبون"
    },

    specialties: {
        "en": "Specialties",
        "ar": "تخصصات الزبائن"
    },

    // samples
    supervisorRemainingSamples: {
        "en": "Remaining Samples",
        "ar": "المواد المتبقية"
    },

    samplesStatement: {
        "en": "Samples statement",
        "ar": "كشف مواد",
    },

    DeliverItems: {
        "en": "Deliver items",
        "ar": "تسليم مواد"
    },

    addPharmaceuticalForm: {
        "en": "Add pharmaceutical form",
        "ar": 'إضافة شكل '
    },

    editPharmaceuticalForm: {
        "ar": 'تعديل شكل ',
        "en": "Edit pharmaceutical form"
    },

    thePharmaceuticalForm: {
        "ar": 'الشكل؟',
        "en": "the pharmaceutical form?"
    },

    pharmaceuticalForm: {
        "en": "Pharmaceutical forms",
        "ar": "الشكل"
    },

    "medicalRepPlan": {
        "en": "Rep plan",
        "ar": ""
    },
    "medicalVisits": {
        "en": "Rep visits",
        "ar": ""
    },
    "MedicalReps": {
        "en": "Rep",
        "ar": ""
    },
    "preCallAnalysis": {
        "en": "pre call analysis",
        "ar": "تقييم الزيارة"
    },
    "call": {
        "en": "Call",
        "ar": "تقييم الزيارة"
    },
    "pharmacistInfo": {
        "en": "Pharmacist info",
        "ar": "اسم الزبون"
    }

}